module.exports = "https://static-production.npmjs.com/58a19602036db1daee0d7863c94673a4.png";